import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import AdminLayout from "@/components/AdminLayout";
import { api } from "@/lib/api";
import { Card } from "@/components/admin/challenge/ChallengeAdminParts";

const btn = "rounded-full bg-[#4563BB] px-5 py-2 text-sm font-semibold text-white disabled:opacity-50";

export default function AdminDream100() {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/dream100/status").then((r) => setSt(r.data)).catch(() => toast.error("Status nicht ladbar"));
  useEffect(() => { load(); }, []);

  const connect = async () => {
    const { data } = await api.post("/admin/dream100/connect");
    window.location.href = data.authorize_url;
  };
  const test = async () => {
    setBusy(true);
    try { await api.post("/admin/dream100/test", {}, { timeout: 120000 }); await load(); toast.success("Test abgeschlossen"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Test fehlgeschlagen"); }
    finally { setBusy(false); }
  };
  const params = new URLSearchParams(window.location.search);

  return (
    <AdminLayout>
      <div className="space-y-5 max-w-4xl" data-testid="admin-dream100-page">
        <header>
          <p className="text-xs font-bold uppercase tracking-widest text-[#4563BB]">Admin · Dream 100</p>
          <h1 className="text-2xl font-bold text-slate-900">Machbarkeitstest Metricool</h1>
          <p className="mt-1 text-sm text-slate-600">Nur Lesen (Berechtigung „mcp:read“). Kein Zeitplan, kein Bericht, keine Interaktion.</p>
        </header>
        {params.get("error") && <p className="text-sm font-semibold text-red-700" data-testid="dream100-error">Verbindung fehlgeschlagen: {params.get("error")}</p>}
        {st && (
          <Card title="Verbindung" testId="dream100-connection-card">
            <p className="text-sm" data-testid="dream100-status">
              {st.connected ? `Verbunden seit ${st.connected_at} · Berechtigung: ${st.scope || "nicht angegeben"}` : "Nicht verbunden"}
            </p>
            <div className="flex gap-3">
              <button className={btn} onClick={connect} data-testid="dream100-connect-btn">{st.connected ? "Neu verbinden" : "Mit Metricool verbinden"}</button>
              <button className={btn} onClick={test} disabled={!st.connected || busy} data-testid="dream100-test-btn">{busy ? "Läuft …" : "Lese-Test ausführen"}</button>
            </div>
          </Card>
        )}
        {st?.last_test && (
          <Card title={`Rohdaten letzter Test (${st.last_test.at})`} testId="dream100-raw-card">
            <pre className="max-h-[70vh] overflow-auto rounded bg-slate-900 p-4 text-xs text-slate-100" data-testid="dream100-raw">
              {JSON.stringify(st.last_test, null, 2)}
            </pre>
          </Card>
        )}
      </div>
    </AdminLayout>
  );
}
